import styled from 'styled-components';
import { Rect } from 'dragonmouse-shared/geometry';
import { unthemed } from 'tokens';

interface BaseProps {
	sceneBounds: Rect;
	backgroundColor?: string;
}
export const Base = styled.div<BaseProps>`
	position: absolute;
	top: ${(p) => p.sceneBounds.y}px;
	left: ${(p) => p.sceneBounds.x}px;
	width: ${(p) => p.sceneBounds.width}px;
	height: ${(p) => p.sceneBounds.height}px;
	background: ${(p) => p.backgroundColor ?? unthemed.gray[900]};

	img,
	iframe {
		border: none;
		position: absolute;
		top: 0;
		left: 0;
	}
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: ${unthemed.gray[900]}bb;
	overflow: hidden;
`;

export const CenterStack = styled.div`
	position: absolute;
	top: 45%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	pointer-events: none;
`;
